// Dependencies
// -----------------------------------------------
import React from 'react';
import get from 'lodash/get';
import moment from 'moment';
import ReactI18n from 'react-i18n';
import chargeDescription from '../../utils/charge-description';
import {
  chargeRefundStatusLabel,
  refundTotal,
  settledGuestCharges
} from '../../utils/guest-charges';

// -----------------------------------------------
// COMPONENT->PRICING(RECEIPT) -------------------
// -----------------------------------------------
export default class InfoPricing extends React.Component {

  // Render Charge
  // ---------------------------------------------
  renderCharge(charge) {
    const translate = ReactI18n.getIntlMessage;
    const amount_charged = parseFloat(charge.amount_charged).toFixed(2);
    const description = [
      chargeDescription(charge, translate),
      chargeRefundStatusLabel(charge, translate)
    ]
      .filter(Boolean)
      .join(' · ');

    return (
      <tr key={charge.id}>
        <td>
          <div>
            {moment(charge.created_at).format(
              get(this, 'props.displayFormat') === 'DD/MM/YYYY'
                ? 'D MMMM, YYYY'
                : 'MMMM D, YYYY'
            )}
          </div>
          <small>{description}</small>
        </td>
        <td>
          -{' '}
          {translate(`global.parsers.currency.${charge.currency}`, {
            value: amount_charged
          })}
        </td>
      </tr>
    );
  }

  // Render Refunded
  // ---------------------------------------------
  renderRefunded(refunded) {
    const translate = ReactI18n.getIntlMessage;
    if (!(refunded > 0)) return null;

    return (
      <tr className="refund">
        <td>
          <div>{translate(`cx.receipt.refunded`)}</div>
        </td>
        <td>
          +{' '}
          {translate(`global.parsers.currency.${this.props.currency}`, {
            value: refunded.toFixed(2)
          })}
        </td>
      </tr>
    );
  }

  // Render
  // ---------------------------------------------
  render() {
    const translate = ReactI18n.getIntlMessage;
    const total = (Math.floor(parseFloat(this.props.booking.price_total) * 100)/100).toFixed(2);
    const paid = (Math.floor(parseFloat(this.props.booking.price_paid) * 100)/100).toFixed(2);
    let remaining = (total - paid).toFixed(2);

    if (remaining < 0) {
      remaining = (0).toFixed(2);
    }
    const charges = settledGuestCharges(this.props.charges);
    const refunded = refundTotal({
      charges,
      refunds: this.props.refunds,
      pricePaid: this.props.booking.price_paid
    });

    return (
      <section className="receipt-info-section">
        <div className="receipt-info-subsection">
          <h3>{translate(`cx.global.payment_information`)}</h3>
          <table className="receipt-pricing-breakdown">
            <tbody>
              <tr className="total">
                <td>{translate(`cx.global.total`)}</td>
                <td>
                  {translate(`global.parsers.currency.${this.props.currency}`, {
                    value: total
                  })}
                </td>
              </tr>
              {charges.map(charge => this.renderCharge(charge))}
              {this.renderRefunded(refunded)}
              <tr className="remaining">
                <td>{translate(`cx.global.remaining`)}</td>
                <td>
                  {translate(`global.parsers.currency.${this.props.currency}`, {
                    value: remaining
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}
